export default __webpack_public_path__ + "static/media/Jenny_Timur-517_websize.98495e01.jpg";